import { t } from 'ttag';

const EVENT_LANGUAGES = () => [
  {
    label: t`Arabic`,
    value: 'arabic',
    code: 'ar',
  },
  {
    label: t`Chinese`,
    value: 'mandarin',
    code: 'zh',
  },
  {
    label: t`Chinese (Traditional)`,
    value: 'chinese(trad)',
    code: 'zh-Hant',
  },
  {
    label: t`Czech`,
    value: 'czech',
    code: 'cs',
  },
  {
    label: t`Danish`,
    value: 'danish',
    code: 'da_DK',
  },
  {
    label: t`Dutch`,
    value: 'dutch',
    code: 'nl',
  },
  {
    label: t`English (US)`,
    value: 'english',
    code: 'en',
  },
  {
    label: t`English (UK)`,
    value: 'english(uk)',
    code: 'en_GB',
  },
  {
    label: t`Estonian`,
    value: 'estonian',
    code: 'et',
  },
  {
    label: t`Finnish`,
    value: 'finnish',
    code: 'fi',
  },
  {
    label: t`French`,
    value: 'french',
    code: 'fr',
  },
  {
    label: t`French (CA)`,
    value: 'french(ca)',
    code: 'fr_CA',
  },
  {
    label: t`German (formal)`,
    value: 'german',
    code: 'de',
  },
  {
    label: t`Hungarian`,
    value: 'hungarian',
    code: 'hu',
  },
  {
    label: t`Indonesian`,
    value: 'indonesian',
    code: 'id',
  },
  {
    label: t`Italian`,
    value: 'italian',
    code: 'it',
  },
  {
    label: t`Japanese`,
    value: 'japanese',
    code: 'ja',
  },
  {
    label: t`Korean`,
    value: 'korean',
    code: 'ko',
  },
  {
    label: t`Norwegian`,
    value: 'norwegian',
    code: 'no',
  },
  {
    label: t`Polish`,
    value: 'polish',
    code: 'pl',
  },
  {
    label: t`Portuguese`,
    value: 'portuguese',
    code: 'pt',
  },
  {
    label: t`Portuguese (Brazilian)`,
    value: 'portuguese(brazilian)',
    code: 'pt_BR',
  },
  {
    label: t`Russian`,
    value: 'russian',
    code: 'ru',
  },
  {
    label: t`Spanish`,
    value: 'spanish',
    code: 'es',
  },
  {
    label: t`Swedish`,
    value: 'swedish',
    code: 'sv',
  },
  {
    label: t`Turkish`,
    value: 'turkish',
    code: 'tr',
  },
];

const MULTI_EVENT_APP_LANGUAGES = () => [
  {
    label: t`Arabic`,
    value: 'ar',
  },
  {
    label: t`Catalan`,
    value: 'ca_ES',
  },
  {
    label: t`Chinese (Simplified)`,
    value: 'zh',
  },
  {
    label: t`Chinese (Traditional)`,
    value: 'zh-Hant',
  },
  {
    label: t`Danish`,
    value: 'da',
  },
  {
    label: t`Dutch`,
    value: 'nl',
  },
  {
    label: t`English (US)`,
    value: 'en',
  },
  {
    label: t`English (UK)`,
    value: 'en_GB',
  },
  {
    label: t`Finnish`,
    value: 'fi',
  },
  {
    label: t`French`,
    value: 'fr',
  },
  {
    label: t`French (CA)`,
    value: 'fr_CA',
  },
  {
    label: t`German (DE)`,
    value: 'de_DE',
  },
  {
    label: t`Indonesian`,
    value: 'id',
  },
  {
    label: t`Italian`,
    value: 'it',
  },
  {
    label: t`Japanese`,
    value: 'ja',
  },
  {
    label: t`Korean`,
    value: 'ko',
  },
  {
    label: t`Polish`,
    value: 'pl',
  },
  {
    label: t`Portuguese`,
    value: 'pt',
  },
  {
    label: t`Portuguese (BR)`,
    value: 'pt_BR',
  },
  {
    label: t`Russian`,
    value: 'ru',
  },
  {
    label: t`Spanish`,
    value: 'es',
  },
  {
    label: t`Swedish`,
    value: 'sv',
  },
  {
    label: t`Turkish`,
    value: 'tr',
  },
];

export const list = (sorted = true, locale = 'en') => {
  const src = EVENT_LANGUAGES();

  if (!sorted) {
    return src;
  }

  if (sorted && (typeof locale === 'undefined' || locale === null)) {
    throw new Error('locale is require for sorting');
  }

  return src.sort((first, second) =>
    first.label.localeCompare(second.label, locale, { sensitivity: 'accent' }),
  );
};

export const listMEA = () => MULTI_EVENT_APP_LANGUAGES();
